import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
//import history from './history';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import 'fontsource-roboto';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-grid.css'
import 'bootstrap/dist/css/bootstrap-reboot.css'

//import reducer from "./store/reducer";
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
// import newPatternReducer from "./store/reducers/newPattern";
// import patternDetailsReducer from "./store/reducers/patternDetails";
import patternLibraryReducer from "./store/reducers/patternLibrary";
import gamesReferenceReducer from "./store/reducers/gamesReference";
import patternExercisesReducer from "./store/reducers/patternExercises";
import userSidebarReducer from "./store/reducers/userSidebar";
import authReducer from './store/reducers/auth';
import modalReducer from './store/reducers/modal';
// import {Helmet} from "react-helmet";

//test shim to address undefined 'process' error
window.process = { env: { NODE_ENV: 'development' } };

const composeEnhancers = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null || compose;

const rootReducer = combineReducers({
    gamesReference: gamesReferenceReducer,
    patternLibrary: patternLibraryReducer,
    patternExercises: patternExercisesReducer,
    userSidebar: userSidebarReducer,
    auth: authReducer,
    modal: modalReducer,
});
// const rootReducer = reducer;

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

ReactDOM.render( app, document.getElementById( 'root' ) );
registerServiceWorker();
